// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f640fe8b","845":"15ca8f24"}[chunkId] + ".chunk.js";
};